import React from "react";
import { Button, Table } from "react-bootstrap";
import { isRMVOrGraniteLocation } from "../../utils/appointmentUtils";

export default function RoadTestResultCard({
  activeKey,
  selectedDays,
  selectedLocation,
  unslotedMembers,
  dataDirty,
  loading,
  slots,
  onSelectNewDay,
  onRefreshStatus,
  onChangeRoadTestStatus,
  onSendRoadTestResultEmailsBulk,
  statusAlerts,
  noDateSelectedPrompt,
  noSlottedStudentsPrompt,
}) {
  function renderRoadTestResultTable(students, usesStudentSlots) {
    return (
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Road Test Result</th>
            <th>Email Sent</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.map((x, index) => {
            return (
              <tr key={x.timestamp}>
                <td>{x.fName + " " + x.lName}</td>
                <td>
                  {x.roadTestPassed ? (
                    <span>
                      {x.roadTestPassed === "noshow"
                        ? "No Show"
                        : x.roadTestPassed === false
                          ? "Not Passed"
                          : "Passed"}
                    </span>
                  ) : (
                    "Not Passed"
                  )}
                </td>
                <td>
                  {x.roadTestLicenseEmailSent ? (
                    <span>
                      {x.roadTestLicenseEmailSent === false
                        ? "Not Sent"
                        : "Sent"}
                    </span>
                  ) : (
                    "Not Sent"
                  )}
                </td>
                <td>
                  <Button
                    disabled={x.roadTestPassed === true}
                    onClick={() =>
                      onChangeRoadTestStatus(
                        index,
                        "markpassed",
                        1,
                        usesStudentSlots,
                      )
                    }
                    size="sm"
                  >
                    Mark Passed
                  </Button>
                  <Button
                    variant="danger"
                    disabled={
                      !x.hasOwnProperty("roadTestPassed") ||
                      x.roadTestPassed === false
                    }
                    onClick={() =>
                      onChangeRoadTestStatus(
                        index,
                        "marknotpassed",
                        1,
                        usesStudentSlots,
                      )
                    }
                    size="sm"
                  >
                    Mark Not Passed
                  </Button>
                  <Button
                    variant="warning"
                    disabled={x.roadTestPassed === "noshow"}
                    onClick={() =>
                      onChangeRoadTestStatus(
                        index,
                        "marknoshow",
                        1,
                        usesStudentSlots,
                      )
                    }
                    size="sm"
                  >
                    Mark No Show
                  </Button>
                  <Button
                    variant="info"
                    disabled={
                      !x.hasOwnProperty("roadTestLicenseEmailSent") ||
                      x.roadTestLicenseEmailSent === false
                    }
                    onClick={() =>
                      onChangeRoadTestStatus(
                        index,
                        "resetRoadTestLicenseEmailSent",
                        1,
                        usesStudentSlots,
                      )
                    }
                    size="sm"
                  >
                    Reset Sent Status
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  return (
    <div>
      {activeKey === "setRoadTestResultEmail" ? (
        <div>{statusAlerts}</div>
      ) : null}

      {selectedDays.length > 0 ? (
        <div>
          {isRMVOrGraniteLocation(selectedLocation) ? (
            <div>
              {unslotedMembers.length === 0 ? (
                <div>
                  <div>No students found. Please select a new day.</div>
                  <br></br>
                  <Button
                    variant="primary"
                    onClick={onSelectNewDay}
                  >
                    Select New Day Range
                  </Button>
                  <br></br>
                </div>
              ) : (
                <div>
                  <Button
                    disabled={dataDirty || loading}
                    onClick={() =>
                      onChangeRoadTestStatus(
                        -100,
                        "markpassed",
                        "all",
                        false,
                      )
                    }
                  >
                    {" "}
                    Mark all students as passed{" "}
                  </Button>
                  <Button
                    disabled={dataDirty || loading}
                    onClick={() =>
                      onSendRoadTestResultEmailsBulk(
                        false,
                        "roadTestPassed",
                        null,
                        (x) =>
                          x.roadTestPassed === true &&
                          (x.roadTestLicenseEmailSent === false ||
                            !x.hasOwnProperty("roadTestLicenseEmailSent")),
                      )
                    }
                  >
                    {" "}
                    Send all unsent emails to passed students{" "}
                  </Button>
                  <Button
                    disabled={dataDirty || loading}
                    onClick={() =>
                      onSendRoadTestResultEmailsBulk(
                        false,
                        "roadTestFailed",
                        null,
                        (x) =>
                          (x.roadTestPassed === false ||
                            !x.hasOwnProperty("roadTestPassed")) &&
                          (x.roadTestLicenseEmailSent === false ||
                            !x.hasOwnProperty("roadTestLicenseEmailSent")),
                      )
                    }
                  >
                    {" "}
                    Send all unsent emails to failed students{" "}
                  </Button>
                  <Button
                    className="rightBut"
                    disabled={dataDirty}
                    onClick={onRefreshStatus}
                  >
                    {" "}
                    Refresh Status{" "}
                  </Button>
                  <br></br>
                  <br></br>
                  {!dataDirty
                    ? renderRoadTestResultTable(
                        unslotedMembers,
                        false,
                      )
                    : null}
                </div>
              )}
            </div>
          ) : (
            <div>
              {slots.length === 0 ? (
                noSlottedStudentsPrompt
              ) : (
                <div>
                  <Button
                    disabled={dataDirty || loading}
                    onClick={() =>
                      onChangeRoadTestStatus(
                        -100,
                        "markpassed",
                        "all",
                        true,
                      )
                    }
                  >
                    {" "}
                    Mark all students as passed{" "}
                  </Button>
                  <Button
                    disabled={dataDirty || loading}
                    onClick={() =>
                      onSendRoadTestResultEmailsBulk(
                        true,
                        "roadTestPassed",
                        (x) =>
                          x.value.roadTestPassed === true &&
                          (x.value.roadTestLicenseEmailSent === false ||
                            !x.value.hasOwnProperty(
                              "roadTestLicenseEmailSent",
                            )),
                        null,
                      )
                    }
                  >
                    {" "}
                    Send all unsent emails to passed students{" "}
                  </Button>
                  <Button
                    disabled={dataDirty || loading}
                    onClick={() =>
                      onSendRoadTestResultEmailsBulk(
                        true,
                        "roadTestFailed",
                        (x) =>
                          (x.value.roadTestPassed === false ||
                            !x.value.hasOwnProperty("roadTestPassed")) &&
                          (x.value.roadTestLicenseEmailSent === false ||
                            !x.value.hasOwnProperty(
                              "roadTestLicenseEmailSent",
                            )),
                        null,
                      )
                    }
                  >
                    {" "}
                    Send all unsent emails to failed students{" "}
                  </Button>
                  <Button
                    className="rightBut"
                    disabled={dataDirty}
                    onClick={onRefreshStatus}
                  >
                    {" "}
                    Refresh Status{" "}
                  </Button>
                  <br></br>
                  <br></br>
                  {!dataDirty
                    ? renderRoadTestResultTable(
                        slots
                          .filter(
                            (x) =>
                              Object.keys(x.value).length > 0 &&
                              x.value.constructor === Object,
                          )
                          .map((x) => x.value),
                        true,
                      )
                    : null}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        noDateSelectedPrompt
      )}
    </div>
  );
}
